import React from 'react';
import { motion } from 'framer-motion';

const ParadigmShift = () => (
  <section
    id="heilung"
    className="relative py-36 overflow-hidden border-t border-gold/20"
  >
    <div className="absolute inset-0 bg-darker" />
    <motion.div
      animate={{ opacity: [0.3, 0.7, 0.3], scale: [1, 1.08, 1] }}
      transition={{ duration: 9, repeat: Infinity }}
      className="absolute inset-0 pointer-events-none"
      style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(212,175,55,0.08) 0%, transparent 65%)' }}
    />
    {/* Rising particles */}
    {[...Array(22)].map((_, i) => (
      <motion.div
        key={i}
        className="absolute rounded-full bg-gold pointer-events-none"
        style={{
          width: Math.random() * 4 + 1,
          height: Math.random() * 4 + 1,
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          opacity: 0.2,
        }}
        animate={{ y: [-50, -150, -250], opacity: [0.3, 0.5, 0] }}
        transition={{ duration: 4 + Math.random() * 5, repeat: Infinity, delay: Math.random() * 5 }}
      />
    ))}
    <motion.div
      animate={{ opacity: [0.2, 0.5, 0.2] }}
      transition={{ duration: 4, repeat: Infinity }}
      className="absolute inset-8 pointer-events-none"
      style={{
        border: '1px solid rgba(212,175,55,0.2)',
        borderRadius: '2px',
        boxShadow: '0 0 80px rgba(212,175,55,0.06), inset 0 0 80px rgba(212,175,55,0.03)',
      }}
    />

    <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
      <motion.p
        initial={{ opacity: 0, letterSpacing: '0.1em' }}
        whileInView={{ opacity: 1, letterSpacing: '0.45em' }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className="text-gold uppercase text-xs font-semibold mb-10"
        style={{ textShadow: '0 0 20px rgba(212,175,55,0.6)' }}
      >
        Der Paradigmen-Wechsel · Dein Weg der Heilung
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="text-5xl md:text-7xl font-serif text-cream leading-tight mb-12"
      >
        Was passiert, wenn du{' '}
        <span
          className="italic text-transparent bg-clip-text bg-gold-gradient"
          style={{ filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.4))' }}
        >
          aufhörst zu jagen
        </span>{' '}
        und anfängst zu heilen?
      </motion.h2>

      <div className="space-y-8 text-lg text-cream/70 font-light leading-relaxed mb-14 text-left">
        {[
          {
            delay: 0.2,
            text: 'Stell dir vor, du holst die gesamte Energie, die du in ihn, in seine Gedanken, in seine Entscheidungen, in seine Vergangenheit investiert hast – zurück zu dir. Diese Energie ist nicht verloren. Sie wartet auf dich. Sie ist deine Schöpferkraft, deine Intuition, deine Vitalität. In dem Moment, in dem du aufhörst, dich energetisch um jemanden zu drehen, der sich nicht vollständig für dich entschieden hat, beginnt sich etwas Fundamentales in deinem Körper zu verschieben.',
          },
          {
            delay: 0.4,
            highlight: true,
            text: 'Echte emotionale Unabhängigkeit fühlt sich nicht wie Einsamkeit an. Sie fühlt sich wie der erste tiefe Atemzug nach langer Zeit an.',
          },
          {
            delay: 0.6,
            text: 'Du wirst beginnen, in deinem eigenen Körper Sicherheit zu finden – eine Sicherheit, die nicht davon abhängt, ob er antwortet, ob er bleibt, ob er sich entscheidet. Diese innere Sicherheit ist das Fundament, auf dem echte, reife, nährende Liebe entstehen kann. Nicht Liebe aus Mangel. Nicht Liebe aus Angst. Liebe aus Fülle. Liebe, die sich wie Ruhe anfühlt, nicht wie ein Sturm.',
          },
          {
            delay: 0.8,
            gold: true,
            text: 'Das ist die Transformation. Nicht ihn zu verlieren. Sondern dich wiederzufinden.',
          },
        ].map((block, i) => (
          <motion.p
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: block.delay, duration: 0.8 }}
            className={`${
              block.gold
                ? 'text-gold font-serif italic text-2xl text-center'
                : block.highlight
                ? 'text-cream font-serif italic text-xl text-center'
                : ''
            }`}
          >
            {block.text}
          </motion.p>
        ))}
      </div>
    </div>
  </section>
);

export default ParadigmShift;